import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrl: './status-bar.component.scss'
})
export class StatusBarComponent implements OnInit, OnChanges {
  @Input() properties!: Status[];
  @Input() isClickable: boolean = false;
  @Output() numberClicked = new EventEmitter<void>();

  ngOnInit(): void {
    this.updateWidths();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['properties']) {
      this.updateWidths();
    }
  }

  updateWidths(): void {
    this.properties.forEach(property => {
      property.width = this.calculateWidth(property.value, property.total);
    });
  }

  calculateWidth(value?: number, total?: number): number {
    const valueNum = value ?? 0;
    const totalNum = total ?? 1; // Avoid division by zero
    return (valueNum / totalNum) * 100;
  }

  numberClickable(): void {
    if (this.isClickable) {
      this.numberClicked.emit();
    }
  }
}

export interface Status {
  name?: string;
  value?: number;
  total?: number;
  width?: number;
  percent?: number;
}